//-------------------------------------------------------------------------------------
//
//	GfxApp
//
//		
//
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
//	Imports
//-------------------------------------------------------------------------------------
import { Transform } from "../../VectorUtilsJS/src/VectorUtilLib.js";
import { GfxDrawing, GfxPath } from "../../GfxContainer/src/GfxDrawing.js";
import { GfxRender } from "../../GfxContainer/src/GfxRender.js";

//=====================================================================================
//
//	GfxApp
//
//	gfxAppInfo = {
//		name: "[appName]", 
//		defaultSettings = {}, 
//		controlGroups = [], 
//		appConfig = {}
//	}
//=====================================================================================

function GfxApp(gfxAppInfo = {})
{
	// Copy the parameters
	this.appId           = (gfxAppInfo.appId)           ? JSON.parse(JSON.stringify(gfxAppInfo.appId)) : undefined;
	this.appName         = (gfxAppInfo.name)            ? JSON.parse(JSON.stringify(gfxAppInfo.name)) : "BaseGfxApp";
	this.defaultSettings = (gfxAppInfo.defaultSettings) ? JSON.parse(JSON.stringify(gfxAppInfo.defaultSettings)) : {};
	this.controlGroups   = (gfxAppInfo.controlGroups)   ? JSON.parse(JSON.stringify(gfxAppInfo.controlGroups)) : [];
	this.appConfig       = (gfxAppInfo.appConfig)       ? JSON.parse(JSON.stringify(gfxAppInfo.appConfig)) : {};
	
	// Initialize the remainder of the object
	this.Reset();
}

//-------------------------------------------------------------------------------------
//	Get Control List
//
//	* Override unnecessary
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetControlList = function()
{
	return this.controlGroups;
}

//-------------------------------------------------------------------------------------
//	Get App Config
//
//	* Override unnecessary
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetConfig = function()
{
	return this.appConfig;
}

//-------------------------------------------------------------------------------------
//	Reset
//
//	* Override should not be needed
//-------------------------------------------------------------------------------------
GfxApp.prototype.Reset = function()
{
	this.settings = Object.assign({}, this.defaultSettings);
	this.gfxDrawing  = undefined;
}

//-------------------------------------------------------------------------------------
//	Set Property
//
//	* Override if you need to monitor property changes or if not using this.settings
//-------------------------------------------------------------------------------------
GfxApp.prototype.SetProperty = function(property, value)
{
	this.settings[property] = value;
}

//-------------------------------------------------------------------------------------
//	Get Property
//
//	* Override if modifying properties returned or if not using this.settings
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetProperty = function(property)
{
	var value = undefined;
	
	value = this.settings[property];
	
	return value;
}

//-------------------------------------------------------------------------------------
//	Get Name
//
//	* Override unnecessary
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetName = function()
{
	return this.appName;
}

//-------------------------------------------------------------------------------------
//	Get AppID
//
//	* Override unnecessary
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetAppId = function()
{
	return this.appId;
}

//-------------------------------------------------------------------------------------
//	Name Matches
//
//	* Override to match name variations
//-------------------------------------------------------------------------------------
GfxApp.prototype.NameMatches = function(appName)
{
	return (this.appName === appName);
}

//-------------------------------------------------------------------------------------
//	AppId Matches
//
//	* Override to match name variations
//-------------------------------------------------------------------------------------
GfxApp.prototype.AppIdMatches = function(appId)
{
	return (this.appId === appId);
}

//-------------------------------------------------------------------------------------
//	Generate
//
//	* Always Override
//-------------------------------------------------------------------------------------
GfxApp.prototype.Generate = function()
{
}

//-------------------------------------------------------------------------------------
//	Render To Context
//
//	* Override if not using GfxDrawing
//-------------------------------------------------------------------------------------
GfxApp.prototype.RenderToContext = function(context, viewTransform)
{
	if (this.gfxDrawing != undefined)
		GfxRender.RenderGfxDrawing(context, this.gfxDrawing, viewTransform);
}

//-------------------------------------------------------------------------------------
//	Render To SVG
//
//	* Override if not using GfxDrawing
//-------------------------------------------------------------------------------------
GfxApp.prototype.RenderToSVG = function(gfxAppData = undefined)
{
	var svg = undefined;
	
	if (this.gfxDrawing != undefined)
		svg = GfxRender.RenderGfxDrawingToSVG(this.gfxDrawing, gfxAppData);
		
	return svg;
}

//-------------------------------------------------------------------------------------
//	Get Dimensions
//
//	* Override if not using GfxDrawing
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetDimensions = function()
{
	var dimensions = undefined;
	
	if (this.gfxDrawing != undefined)
	{
		var bounds = this.gfxDrawing.FindBounds();
		
		if (bounds != undefined)
			dimensions = {x:(bounds.max.x - bounds.min.x), y:(bounds.max.y - bounds.min.y)};
	}
	
	return dimensions
}

//-------------------------------------------------------------------------------------
//	Get Bounds
//
//	* Override if not using GfxDrawing
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetBounds = function()
{
	var bounds = undefined;
	
	if (this.gfxDrawing != undefined)
		bounds = this.gfxDrawing.FindBounds();
	
	return bounds
}

//-------------------------------------------------------------------------------------
//	Get Info
//
//	* Override to provide info to display
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetInfo = function()
{
	var info = undefined;
	
	//info = JSON.parse(JSON.stringify(this.appName));
	
	return info;
}

//-------------------------------------------------------------------------------------
//	Get Status
//
//	* Override to provide info to display
//	Return
//	{ message:str, warning:str, error:str}
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetStatus = function()
{
	var status = undefined;
	
	//status = { message:"message-str", warning:"warning-str", error:"error-str" };
	
	return status;
}

//-------------------------------------------------------------------------------------
//	Get Settings Copy
//		This will return a copy of the gfxApp's settings
//
//	* Override if not using this.settings
//-------------------------------------------------------------------------------------
GfxApp.prototype.GetSettingsCopy = function()
{
	var settingsCopy = undefined;
	
	if (this.settings != undefined)
		settingsCopy = JSON.parse(JSON.stringify(this.settings));
	
	return settingsCopy;
}

//-------------------------------------------------------------------------------------
//	Update Settings
//		Update the settings with the provided values
//
//	* Override if not using this.settings
//-------------------------------------------------------------------------------------
GfxApp.prototype.UpdateSettings = function(settings)
{
	// Make a copy in case the 'settings' parameter has objects within it.
	// The settings copy will have its own copy of the embedded objects, which
	// we then take ownership of.
	let settingsCopy = JSON.parse(JSON.stringify(settings));
	
	Object.assign(this.settings, settingsCopy);
}


//-------------------------------------------------------------------------------------
//	Public
//-------------------------------------------------------------------------------------
export { GfxApp };

